import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { setAreaLevel, getAreaLevel } from '../../reducer/areaLevelSlice';
import { useState } from 'react';

function AreaLevelSetting() {
    const areaLevel = useSelector(getAreaLevel);
    const dispatch = useDispatch();
    const [areaLevelSelected, setAreaLevelSeleceted] = useState(areaLevel);

    const handleChange = (event, newValue) => {
        setAreaLevelSeleceted(event.target.value);
        dispatch(setAreaLevel(event.target.value));
    };
    return (
        <>
            <Box className="pt-2 pb-4">
                <Typography variant="subtitle1" className='mt-4 mb-2'>
                    ระดับพื้นที่การแสดงผล
                </Typography>
                <ToggleButtonGroup
                    fullWidth
                    value={areaLevelSelected}
                    exclusive
                    onChange={handleChange}
                    size='small'
                >
                    <ToggleButton className='text-base text-blue-gray-900' value="region">เขต</ToggleButton>
                    <ToggleButton className='text-base text-blue-gray-900' value="province">จังหวัด</ToggleButton>
                    <ToggleButton className='text-base text-blue-gray-900' value="amphur">อำเภอ</ToggleButton>
                    <ToggleButton className='text-base text-blue-gray-900' value="tambon">ตำบล</ToggleButton>
                </ToggleButtonGroup>
                {/* <Tabs 
                    value={areaLevelSelected}
                    variant="fullWidth"
                    onChange={handleChange}
                    sx={{
                        marginTop: '8px',
                        minHeight: '34px',
                        height: '34px',
                        backgroundColor: 'rgba(0, 0, 0, 0.23)',
                        borderRadius: '4px',
                        '& .MuiTabs-indicator': {
                            backgroundColor: 'rgb(212, 135, 108)',
                            zIndex: 1,
                            height: '100%'
                        }
                    }}
                >
                    <StyledTab label="เขต" value="region" />
                    <StyledTab label="จังหวัด" value="province" />
                    <StyledTab label="อำเภอ" value="amphur" />
                    <StyledTab label="ตำบล" value="tambon" />
                </Tabs> */}
            </Box>
        </>
    )
}

export default AreaLevelSetting;